import { AxiosNotification, userId } from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";


export const Notification = {
   $_getAllNotifications(params){
    const url = `/notification/${userId()}/muleex/${appendQueryParams(params)}`;
    return AxiosNotification.get(url);
   },
   $_markAllAsRead(payload) {
      const url = `/notification/mark-as-read`;
      return AxiosNotification.patch(url, payload);
    },
    $_deleteNotification(id){
      const url = `/notification/delete/${id}`;
      return AxiosNotification.patch(url, {});
     },
     $_deleteAllNotification(){
      const url = `/notification/all/delete/${userId()}`;
      return AxiosNotification.patch(url, {});
     },
};
